require('./command.js');

(function(){
  PegasusTemplate.CopyRowCommand = PegasusTemplate.Command.extend({
    klass: null,
    sourceElement: null,
    callback: null,
    parent: null,
    desiredPosition: null,
    descriptionClass: 'copied',
    description: function(){
      return Em.I18n.t('command_descriptions.copied_row');
    }.property(),
    execute: function() {
      var parent = PegasusTemplate.blockRegionInstance,
        element = this.get('klass').create({
          container: parent.container,
          sourceElement: this.get('sourceElement')
        }),
        callback = this.get('callback'),
        _super = this._super.bind(this);

      parent.insertAt( this.get('desiredPosition'), element );

      if ( callback ) {
        callback();
      }

      Em.run.scheduleOnce( 'afterRender', element, function(){
        this.set('isVisible', true);
        this.$().addClass('bounce-in-down').addClass('animated').addClass('make_transit');
        _super();
      });
    },

    unexecute: function(callback){
      var parent = PegasusTemplate.blockRegionInstance,
        child = parent.objectAt( this.get('desiredPosition') );

      parent.removeObject(child);
      this._super();
    }
  });
})();

